import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/index';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class ComparableService extends BaseService {
  public url = 'api/souring-normal-quote-dt/query-bid';

  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * 获取url
   * */
  getUrl(): string {
    return this.url;
  }

  /**
   * 获取最近报价信息
   * */
  recentPurchases(id1, id2): Observable<any> {
    const url = `api/purOrderDetail/last-confirm?matId=${id1}&priceType=${id2}`;
    return this.http.get<any>(url, {
      headers: httpOptions.headers,
    }).pipe(
      tap(_ => this.log(`getBidSeal`)),
      catchError(this.handleError<any>(`getBidSeal-log`)),
    );
  }

  /**
   * 获取价格库价格明细
   * */
  getPriceData(id, id1): Observable<any> {
    const url = `api/dynamic-form-value/${id1}/PRICE_DTO_FORM/${id}`;
    return this.http.get<any>(url, {
      headers: httpOptions.headers,
    }).pipe(
      tap(_ => this.log(`getPriceData`)),
      catchError(this.handleError<any>(`getPriceData-log`)),
    );
  }

  /**
   * 开始比较
   * */
  startContrast(sourcingEnrollDto) {
    const url = `api/souring-normal-quote/rate-mat`;
    return this.http.post<any>(url, sourcingEnrollDto, httpOptions).pipe(
      tap((object: any) => this.log(`startContrast`)),
      catchError(this.handleError<any>('startContrast')),
    );
  }

}
